import { FirstPage } from './FirstPage';
import { OptionSelectionPage } from './InsertsPages/pages/OptionSelectionPage';
import { InsertPhotoUpload } from './InsertsPages/pages/InsertPhotoUpload';
import { InsertMessage } from './InsertsPages/pages/InsertMessage';
import { InsertThemedPhotoUpload } from './InsertsPages/pages/InsertThemedPhotoUpload';
import { InsertThemedMessage } from './InsertsPages/pages/InsertThemedMessage';
import { CardPhotoUpload } from './InsertsPages/pages/CardPhotoUpload';
import { CardPredesignedMessage } from './InsertsPages/pages/CardPredesignedMessage';
import { CardCustomMessage } from './InsertsPages/pages/CardCustomMessage';
import { pages } from '../../context/pages';
import { CardThemedPhotoUpload } from './InsertsPages/pages/CardThemedPhotoUpload';
import { CardThemedCustomMessage } from './InsertsPages/pages/CardThemedCustomMessage';

/**
 * Registry mapping page names to their corresponding components.
 * This enables dynamic page rendering based on currentPage state.
 */
export const pageRegistry = {
  firstPage: FirstPage,
  addPersonalTouch: OptionSelectionPage,
  boxInsertUploadOrText: OptionSelectionPage,
  boxInsertPhotoBlankOrThemed: OptionSelectionPage,
  boxInsertTextBlankOrThemed: OptionSelectionPage,
  boxInsertBlankPhotoUpload: InsertPhotoUpload,
  boxInsertBlankMessage: InsertMessage,
  boxInsertThemedPhotoUpload: InsertThemedPhotoUpload,
  boxInsertThemedMessage: InsertThemedMessage,
  cardChoice: OptionSelectionPage,
  cardPhotoUploadThemedOrBlank: OptionSelectionPage,
  cardTextOnlyThemedOrBlank: OptionSelectionPage,
  cardBlankPhotoUpload: CardPhotoUpload,
  cardBlankMessageChoice: OptionSelectionPage,
  cardBlankPredesigned: CardPredesignedMessage,
  cardBlankCustomMessage: CardCustomMessage,
  cardThemedPhotoUpload: CardThemedPhotoUpload,
  cardThemedCustomMessage: CardThemedCustomMessage
};

/**
 * Gets the component for a given page name.
 * @param {string} pageName - The page name.
 * @returns {React.ComponentType | null} The component or null if not found.
 */
export function getPageComponent(pageName) {
  return pageRegistry[pageName] || null;
}

/**
 * Gets additional props needed for a page component based on page configuration.
 * @param {string} pageName - The page name.
 * @returns {Object} Props object to pass to the component.
 */
export function getPageComponentProps(pageName) {
  const pageConfig = pages[pageName];
  
  if (!pageConfig) {
    return {};
  }

  // For OptionSelectionPage components, pass the pageName and headerTitle.
  if (pageConfig.pageType === 'optionSelection') {
    return {
      pageName,
      headerTitle: pageConfig.headerTitle
    };
  }

  return {};
}

